/* src/app/shared/services/dialog/redeem-confirm-dialog/redeem-confirm-dialog.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.confirm-dialog {
  font-size: 1rem;
  padding: 1.8125em 1.625em;
  position: relative;
}
.confirm-dialog .key-key {
  width: 60px;
  height: 3px;
  background: var(--ups-brand-colors-ups-gold, #FFC400);
  margin-top: 15px;
  margin-bottom: 5px;
}
.confirm-dialog .close-button {
  position: absolute;
  top: 18px;
  right: 27px;
  background: none;
  outline: none;
}
.confirm-dialog .close-button.cdk-focused.cdk-keyboard-focused {
  border: none;
  outline: none;
  background: none;
}
.confirm-dialog .mat-mdc-dialog-title {
  font-size: 36px;
}
.confirm-dialog .mat-mdc-dialog-title + .mat-mdc-dialog-content {
  margin-top: -1em;
}
.confirm-dialog .mat-mdc-dialog-title.note-title {
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 700;
  color: #817b7b;
}
.confirm-dialog .mat-mdc-radio-button {
  display: block;
}
.confirm-dialog .spanned_invoiceID {
  color: #0662BB;
  text-align: center;
  text-decoration-line: underline;
}
.confirm-dialog .invoice-wrapper {
  display: flex;
  align-items: center;
  padding-bottom: 5px;
}
.confirm-dialog .invoice-wrapper .invoice-form-field {
  margin-left: 20px;
  width: 24em;
}
.confirm-dialog .invoice-wrapper ::ng-deep .mat-mdc-form-field {
  font-size: 14px;
}
.confirm-dialog .invoice-wrapper ::ng-deep .mat-mdc-form-field .mat-form-field-wrapper {
  padding: 0px;
  margin-bottom: 15px;
}
.confirm-dialog .invoice-wrapper ::ng-deep .mat-form-field-outline {
  color: #5c5c5c;
}
.confirm-dialog .available-points h2 {
  font-size: 18px;
  margin-top: 16px;
  color: #000;
}
.confirm-dialog .available-points h5 {
  margin-top: 15px;
  color: #000;
  font-size: 16px;
}
.confirm-dialog .available-points + .available-points-btns {
  display: flex;
}
.confirm-dialog .available-points button,
.confirm-dialog .available-points .mat-mdc-button {
  background: var(--semantic-colors-ups-progress-blue-light, #E6EFF8);
  color: #064D93;
  margin: 10px 9px 0px 0px;
  border-radius: 8px;
  font-size: 12px;
}
.confirm-dialog .custom-amount {
  margin-top: 15px;
}
.confirm-dialog .custom-amount h6 {
  margin-top: 10px;
  font-weight: 600;
}
.confirm-dialog .custom-amount .custom-amount-label {
  color: #8c8c8c;
}
.confirm-dialog .custom-amount .custom-amount-form-field {
  width: 350px;
}
.confirm-dialog .custom-amount ::ng-deep .custom-amount-form-field .mat-form-field-wrapper {
  padding: 0;
}
.confirm-dialog .custom-amount ::ng-deep .mat-mdc-form-field {
  font-size: 14px;
}
.confirm-dialog .custom-amount ::ng-deep .mat-form-field-outline {
  color: #5c5c5c;
}
.confirm-dialog .custom-amount ::ng-deep .mat-placeholder-required {
  display: none;
}
.confirm-dialog .custom-amount .my-error {
  font-size: 13px;
  max-width: 28em;
}
.confirm-dialog .mat-mdc-dialog-actions {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  margin-top: 1.25em;
  margin-bottom: 0;
  padding: 0;
}
@media screen and (min-width: 48rem) {
  .confirm-dialog .mat-mdc-dialog-actions {
    flex-direction: row;
  }
}
.confirm-dialog .mat-mdc-dialog-actions button,
.confirm-dialog .mat-mdc-dialog-actions .mat-mdc-raised-button {
  width: 100%;
  margin: 0 0 0.5rem 0;
  padding: 10px 14px 10px 24px;
  background: var(--ups-brand-colors-ups-gold, #FFC400);
  border: none;
  border-radius: 22px;
  color: black;
}
@media screen and (min-width: 48rem) {
  .confirm-dialog .mat-mdc-dialog-actions button,
  .confirm-dialog .mat-mdc-dialog-actions .mat-mdc-raised-button {
    width: auto;
    margin: 0 1rem 0.5rem 0rem;
  }
}
.confirm-dialog .mat-mdc-dialog-actions button.mat-mdc-raised-button[disabled] {
  background: var(--ups-background-color, #f4f4f4);
  color: var(--ups-bray-light, #cac4bd);
}
.confirm-dialog .mat-mdc-dialog-actions .alternative-button {
  background: white;
  border: solid 2px var(--ups-brand-colors-ups-blue-alternate, #0662BB);
  border-radius: 22px;
  color: var(--ups-brand-colors-ups-blue-alternate, #0662BB);
}
.confirm-dialog.alternate .mat-mdc-dialog-content {
  overflow: visible;
}
.confirm-dialog.alternate .mat-mdc-dialog-content .dialog-content {
  font-size: 1.5em;
  font-weight: 700;
  line-height: 1.5;
  text-align: center;
}
.confirm-dialog.alternate .mat-mdc-dialog-actions {
  padding-bottom: 2rem;
  flex-direction: row-reverse;
}
.confirm-dialog.alternate .mat-mdc-dialog-actions .mat-mdc-raised-button {
  height: 33px;
  font-size: 0.8em;
  line-height: 1;
}
.confirm-dialog .content-disabled {
  pointer-events: none;
  opacity: 2;
  -webkit-user-select: none;
  user-select: none;
  cursor: not-allowed;
}
.invoiceid-container h2 {
  font-size: 18px;
  margin-top: 16px;
  color: #000;
}
::ng-deep .mat-mdc-dialog-title {
  margin: 0;
}
.singleInvoice-mat-dialog-content {
  padding: 0;
}
.notSingleInvoice-mat-dialog-content {
  padding: 1em 0 0 0;
  overflow: visible;
}
/*# sourceMappingURL=redeem-confirm-dialog.component.css.map */
